import { render } from "./AmazonDSPAdsAccountSelectionPage.vue?vue&type=template&id=1315df3c&scoped=true"
import script from "./AmazonDSPAdsAccountSelectionPage.vue?vue&type=script&lang=js"
export * from "./AmazonDSPAdsAccountSelectionPage.vue?vue&type=script&lang=js"

import "./AmazonDSPAdsAccountSelectionPage.vue?vue&type=style&index=0&id=1315df3c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1315df3c"]])

export default __exports__